module.exports = __webpack_public_path__ + "static/media/arrow-left-bg.b7a66864.svg";